export default __webpack_public_path__ + "static/media/home.3cfeeb70.svg";